import React, { Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import store from 'store'
import Layout from 'layouts'
import ACL from 'components/system/ACL'
import ProductPlan from 'components/system/ProductPlan'
import RouteAccess from 'services/route_access'
import Common from 'services/common'
import Conf from 'ui-config'
// React.lazy that reloads once if the chunk is gone after a deploy.
import { lazy } from 'chunkReload'

// const SelectedCluster = localStorage.getItem('SelectedCluster')
//   ? JSON.parse(localStorage.getItem('SelectedCluster'))
//   : null
// const clusterId = SelectedCluster !== null ? SelectedCluster.clusterId : ''
// const eulaComp = lazy(() => import('components/common/eula-content'))
const routes = [
  {
    path: '/:clusterId/:scopeId?/admin/clusters',
    key: 'admin',
    Component: lazy(() => import('pages/admin/cluster/clusterList')),
    roles: [].concat(RouteAccess.ROOT_ROLES).concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/clusters/configure/:id?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/cluster/clusterConnect/coreconnect.js')),
    roles: [].concat(RouteAccess.ROOT_ROLES).concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/components',
    key: 'admin',
    Component: lazy(() => import('pages/admin/component')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/components/:type/:id/health',
    key: 'admin',
    Component: lazy(() => import('pages/admin/component/component-health')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/components/:type/:id/configure',
    key: 'admin',
    Component: lazy(() => import('pages/admin/component/config.js')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/global/:option?',
    key: 'global_views',
    Component: lazy(() => import('pages/admin/global_views')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/smtp',
    key: 'system',
    Component: lazy(() => import('pages/admin/smtp')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/admin/switchboard',
    key: 'admin',
    Component: lazy(() => import('pages/system/switch_board')),
    roles: [].concat(RouteAccess.ROOT_ROLES).concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId?/:scopeId?/admin/organizations/list',
    key: 'admin',
    Component: lazy(() => import('pages/admin/Organisations/list')),
    roles: RouteAccess.ORG_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES).concat(
      RouteAccess.ROOT_INIT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId?/:scopeId?/admin/organizations/:orgId?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/Organisations/view')),
    roles: RouteAccess.ORG_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES).concat(
      RouteAccess.ROOT_INIT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  // {
  //   path: '/:clusterId/:scopeId?/admin/user/list',
  //   key: 'admin',
  //   Component: lazy(() => import('pages/admin/user-management')),
  //   roles: RouteAccess.ROOT_ROLES,
  //   exact: true,
  //   productTypes: ['essential', 'professional', 'enterprise'],
  // },
  {
    path: '/:clusterId/:scopeId?/admin/user/:id?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/user-management/add-edit-user')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId?/:scopeId?/admin/tenants/configure/:id?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/Tenants/list/coreconnect')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES).concat(
      RouteAccess.ROOT_INIT_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId?/:scopeId?/admin/tenants/list',
    key: 'admin',
    Component: lazy(() => import('pages/admin/Tenants/list')),
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId?/:scopeId?/admin/tenants/:clusterId?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/Tenants/view')),
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/auth/login',
    key: 'login',
    Component: lazy(() => import('components/system/Auth')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/auth/login/verify-otp',
    key: 'OTPValidation',
    Component: lazy(() => import('components/system/Auth/VerifyOTP')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/auth/sso/:token',
    key: 'sso',
    Component: lazy(() => import('components/system/Auth/SSO')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/auth/handoff/:token',
    key: 'handoff',
    Component: lazy(() => import('components/system/Auth/Handoff')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/auth/reset-password/:linkType/:token',
    key: 'resetForgotPass',
    Component: lazy(() => import('components/system/Auth/ResetPassword')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/auth/reset-password/forgot_pass',
    key: 'forgotPass',
    Component: lazy(() => import('components/system/Auth/ResetPassword')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/auth/set-password/:token',
    key: 'setPass',
    Component: lazy(() => import('components/system/Auth/SetPassword')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/:clusterId?/:scopeId?/change-password',
    key: 'changepassword',
    Component: lazy(() => import('pages/auth/changePassword')),
    roles: RouteAccess.ALL_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/auth/404',
    key: '404',
    Component: lazy(() => import('pages/auth/404')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/:clusterId/:scopeId?/auth/500',
    key: '500',
    Component: lazy(() => import('pages/auth/500')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/:clusterId?/:scopeId?/no-access/auth/no-access',
    key: 'noAccess',
    Component: lazy(() => import('pages/auth/no-access')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise', ''],
  },
  {
    path: '/:clusterId/:scopeId?/dashboard',
    key: 'dashboard',
    Component: lazy(() => import('pages/dashboard/list')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/dashboard/:type',
    key: 'dashboard',
    Component: lazy(() => import('pages/dashboard/view')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scope_id/:ID/reportlink/:theme?/:licensetype?',
    key: 'reportprint',
    Component: lazy(() => import('pages/reports/view/list.js')),
    roles: RouteAccess.GLOBAL_ACCESS,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/reports',

    key: 'reportslist',
    Component: lazy(() => import('pages/reports/list')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.ROOT_VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scope_id/reports/:type',
    key: 'reportsview',
    Component: lazy(() => import('pages/reports/view/list.js')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.ROOT_VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },

  {
    path: '/:clusterId/:scope_id/reports/:type',
    key: 'demoreportsview',
    Component: lazy(() => import('pages/reports/view')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.ROOT_VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },

  {
    path: '/:clusterId/:scopeId?/system/eventstores',
    key: 'eventstore',
    Component: lazy(() => import('pages/eventstore')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/jobs/scheduled',
    key: 'scheduled',
    Component: lazy(() => import('pages/jobs/scheduled_jobs/index')),
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/jobs/signals',
    key: 'jobs',
    Component: lazy(() => import('pages/jobs/signals/')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  // {
  //   path: '/:clusterId/jobs/scheduled',
  //   key: 'scheduled',
  //   Component: lazy(() => import('pages/jobs/scheduled_jobs/index')),
  //   roles: ['Admin - Security Engineer', 'Admin - SecAdmin Security Engineer', 'User - SecAdmin Security Engineer', 'User - Security Engineer'],
  //   exact: true,
  // },
  // {
  //   path: '/:clusterId/:scopeId?/jobs/signals',
  //   key: 'jobs',
  //   Component: lazy(() => import('pages/jobs/signals/')),
  //   roles: [  //     'Admin - Security Engineer',  //     'Admin - Security Analyst',  //     'User - Security Engineer',  //     'User - Security Analyst',  //   ],
  //   exact: true,
  // },
  // {
  //   path: '/:clusterId/:scopeId/models/visualize/:id?',
  //   key: 'models',
  //   Component: lazy(() => import('pages/models/visualize')),
  //   roles: ['Admin - Security Engineer', 'User - Security Engineer'],
  //   exact: true,
  // },
  {
    path: '/:clusterId/:scopeId?/incident/signals',
    key: 'incident_signals',
    Component: lazy(() => import('pages/incidents/signal-analyzer')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/incident/cases',
    key: 'incident_cases',
    Component: lazy(() => import('pages/incidents/cases')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/incident/cases/:type',
    key: 'cases',
    Component: lazy(() => import('pages/incidents/cases/cases-analyzer')),
    // The case ANALYZER, withdrawn from a read-only role: a Viewer gets the
    // cases list and not the cases. The list route above keeps its grant.
    // This is the gate; removing the links in pages/incidents/cases/index.js
    // is only the affordance, and a pasted URL would otherwise still open.
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/stream/list',
    key: 'streams',
    Component: lazy(() => import('pages/stream')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES.concat(RouteAccess.VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/collection_status',
    key: 'streams',
    Component: lazy(() => import('pages/devicemgmt/deviceList')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES.concat(RouteAccess.TENANT_ADMIN_ROLES)
      .concat(RouteAccess.ORG_ADMIN_ROLES)
      .concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES)
      .concat(RouteAccess.VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/extraction',
    key: 'system',
    Component: lazy(() => import('pages/admin/Extraction')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/extraction/:type',
    key: 'system',
    Component: lazy(() => import('pages/admin/Extraction/YAMLform.js')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/enrichment',
    key: 'system',
    Component: lazy(() => import('pages/admin/Enrichment')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/enrichment/:type/:name?',
    key: 'system',
    Component: lazy(() => import('pages/admin/Enrichment/YamlForm.js')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/signalsuppression',
    key: 'system',
    Component: lazy(() => import('pages/system/falsepositive')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/geodb',
    key: 'system',
    Component: lazy(() => import('pages/admin/geodb')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/integrations',
    key: 'integrations',
    Component: lazy(() => import('pages/admin/integrations/')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/slow-queries',
    key: 'slowQuery',
    Component: lazy(() => import('pages/longquerymgmt/')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/models',
    key: 'system',
    Component: lazy(() => import('pages/admin/models')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/models/:type/:name?',
    key: 'system',
    Component: lazy(() => import('pages/admin/models/YAMLform.js')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/components',
    key: 'secadmin',
    Component: lazy(() => import('pages/system/cust_admin')),
    roles: RouteAccess.TENANT_ADMIN_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/components/:type/:id/health',
    key: 'secadmin',
    Component: lazy(() => import('pages/system/cust_admin/component-health')),
    roles: RouteAccess.TENANT_ADMIN_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/components/:type/:id/configure',
    key: 'secadmin',
    Component: lazy(() => import('pages/system/cust_admin/config')),
    roles: RouteAccess.TENANT_ADMIN_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/connectors',
    key: 'connectors',
    Component: lazy(() => import('pages/admin/connectors')),
    roles: RouteAccess.TENANT_ADMIN_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/utilization',
    key: 'utilization',
    Component: lazy(() => import('pages/usagepage')),
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.TENANT_ADMIN_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  // Feature-flagged: absent (falls through to /auth/404) unless CUSTOMER_STATS_ENABLED.
  ...(Conf.CUSTOMER_STATS_ENABLED
    ? [
        {
          path: '/:clusterId/:scopeId?/system/customer-stats',
          key: 'customerStats',
          Component: lazy(() => import('pages/system/customer-stats')),
          // Root only, matching lc-api (no Root viewers: bloo-team/saas-console#481).
          // Tenant admins too when CUSTOMER_STATS_TENANT_ENABLED (bloo-team/saas-console#469).
          roles: RouteAccess.ROOT_ROLES.concat(
            Conf.CUSTOMER_STATS_TENANT_ENABLED ? RouteAccess.TENANT_ADMIN_ROLES : [],
          ),
          exact: true,
          productTypes: ['essential', 'professional', 'enterprise'],
        },
      ]
    : []),
  {
    path: '/:clusterId/:scopeId?/system/token',
    key: 'system',
    Component: lazy(() => import('pages/admin/tokenManagement')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/eba',
    key: 'eba',
    Component: lazy(() => import('pages/uba')),
    roles: RouteAccess.SEC_ENGINEERS_ROLES,
    exact: true,
    productTypes: ['enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/streamfieldaddition',
    key: 'streamfieldaddition',
    Component: lazy(() => import('pages/stream-field/list')),
    roles: RouteAccess.CONTENT_MNGR_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/system/streamfieldaddition/:stream',
    key: 'streamfieldaddition',
    Component: lazy(() => import('pages/stream-field/view')),
    roles: RouteAccess.CONTENT_MNGR_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/home/:view?/:id?',
    key: 'home',
    Component: lazy(() => import('pages/home')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId?/:scopeId?/privacy/:url?',
    key: 'home',
    Component: lazy(() => import('pages/privacy')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES)
      .concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.CONTENT_MNGR_ROLES)
      .concat(RouteAccess.VIEWER_ROLES)
      .concat(RouteAccess.ORG_ADMIN_ROLES)
      .concat(RouteAccess.ALL_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/workbook',
    key: 'workbook',
    Component: lazy(() => import('pages/workbook/workbookList')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/workbook/:type/:data?',
    key: 'workbookView',
    Component: lazy(() => import('pages/workbook/workbookView')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(
      RouteAccess.VIEWER_ROLES,
    ),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/mitre_attack',
    key: 'mitre_attack',
    Component: lazy(() => import('pages/mitre')),
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/upgrade/:plan_type',
    key: 'upgrade_plan',
    Component: lazy(() => import('pages/upgradeplan')),
    roles: RouteAccess.ALL_ROLES,
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
]

const mapStateToProps = ({ settings, user }) => ({
  routerAnimation: settings.routerAnimation,
  selectedCluster: user.selectedCluster,
  selectedScope: user.selectedScope,
})

class Router extends React.Component {
  render() {
    const { history, routerAnimation } = this.props
    var loginstatus = localStorage.getItem('loginStatus')
    // var eulastatus = localStorage.getItem('eulaStatus')
    var link = 'auth/login'
    const SelectedAcc = JSON.parse(localStorage.getItem('userPayload'))
    const clusterId = SelectedAcc !== null ? SelectedAcc.clusterId : ''
    const scopeId = SelectedAcc !== null ? SelectedAcc.scope_id : ''
    // var accessData = JSON.parse(localStorage.getItem('accessData'))
    if (loginstatus === 'success') {
      link = history.location.pathname
    }
    return (
      <ConnectedRouter history={history}>
        <Layout>
          <Route
            render={state => {
              const { location } = state
              const version = localStorage.getItem('version')
              if (version === undefined || version === null || version !== Common.version) {
                localStorage.clear()
                sessionStorage.clear()
                localStorage.setItem('version', Common.version)
              }
              return (
                <SwitchTransition>
                  <CSSTransition
                    key={location.pathname}
                    appear
                    classNames={routerAnimation}
                    timeout={routerAnimation === 'none' ? 0 : 300}
                  >
                    <Switch location={location}>
                      <Route
                        exact
                        path="/"
                        render={props =>
                          // <Redirect to="/auth/login" />
                          {
                            return (
                              <div>
                                {!window.location.toString().includes('/reportlink/') && (
                                  <>
                                    {localStorage.getItem('IsInvalid') === 'true' ? (
                                      <Redirect to="/auth/login" />
                                    ) : localStorage
                                        .getItem('UserAcc')
                                        .includes(`${RouteAccess.ROOT} - ${RouteAccess.INIT}`) ? (
                                      <Redirect to={`/admin/tenants/list`} />
                                    ) : localStorage
                                        .getItem('UserAcc')
                                        .includes(`${RouteAccess.VIEWER}`) ? (
                                      <Redirect to={`/${clusterId}/${scopeId}/dashboard`} />
                                    ) : localStorage
                                        .getItem('UserAcc')
                                        .includes(`${RouteAccess.ROOT}`) &&
                                      !localStorage.getItem('UserAcc').includes('Security') ? (
                                      <Redirect to={`/${clusterId}/${scopeId}/admin/components`} />
                                    ) : localStorage
                                        .getItem('UserAcc')
                                        .includes(`${RouteAccess.TENANT_ADMIN}`) &&
                                      !localStorage.getItem('UserAcc').includes('Security') ? (
                                      <Redirect to={`/${clusterId}/${scopeId}/admin/components`} />
                                    ) : // ): localStorage.getItem('UserAcc') === 'OrgAdmin - TenantAdmin' ? (
                                    localStorage
                                        .getItem('UserAcc')
                                        .includes(`${RouteAccess.ORG_ADMIN}`) &&
                                      !localStorage.getItem('UserAcc').includes('Security') ? (
                                      <Redirect to={`/admin/organizations/list`} />
                                    ) : (
                                      <Redirect
                                        to={`/${clusterId}/${scopeId}/home/${scopeId}/${clusterId}`}
                                      />
                                      // <Redirect to={`/${clusterId}/${scopeId !== null && scopeId !== undefined ? scopeId : 'no-access'}/admin/components`} />
                                      // <Redirect to={`/${clusterId}/${scopeId}/workbook/new`} />
                                    )}
                                  </>
                                )}
                              </div>
                            )
                          }
                        }
                      />
                      {routes.map(({ path, key, Component, exact, roles, productTypes }) => (
                        <Route
                          path={path}
                          key={path}
                          exact={exact}
                          render={props => {
                            store.set('app.menu.selectedKeys', [key])
                            return (
                              <div className={routerAnimation}>
                                {!window.location.toString().includes('/reportlink/') ? (
                                  <ProductPlan productTypes={productTypes}>
                                    <ACL roles={roles} redirect={link}>
                                      <Suspense fallback={null}>
                                        <Component />
                                      </Suspense>
                                    </ACL>
                                  </ProductPlan>
                                ) : (
                                  <ProductPlan productTypes={productTypes}>
                                    <ACL roles={roles} redirect={link}>
                                      <Suspense fallback={null}>
                                        <Component />
                                      </Suspense>
                                    </ACL>
                                  </ProductPlan>
                                )}
                              </div>
                            )
                          }}
                        />
                      ))}

                      {/* {clusterId === '' && scopeId === '' ? (
                        <Redirect to={`/auth/no-access`} />
                      ) : ( */}
                      <Redirect to={`/auth/404`} />
                      {/* )} */}
                    </Switch>
                  </CSSTransition>
                </SwitchTransition>
              )
            }}
          />
        </Layout>
      </ConnectedRouter>
    )
  }
}

export { routes }

export default connect(mapStateToProps)(Router)
